import { render } from "./Compte.vue?vue&type=template&id=f9c115b4"
import script from "./Compte.vue?vue&type=script&lang=js"
export * from "./Compte.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phl/phlsupport/deploy-support-cli/front_vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__